import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import SideBar from "./SideBar";
import styled from "styled-components";
import { useEffect, useState } from "react";
import MobileSidebar from "./MobileSidebar";

interface StyleMainProps {
  showsidebar: "true" | "false";
}

const StyledMenu = styled.main<StyleMainProps>`
  overflow-y: scroll;
  overflow-x: hidden;
  margin-top: 60px;
  height: calc(100vh - 60px);
  padding: 20px;
  padding-bottom: 60px;
  background-image: linear-gradient(180deg, #ffffff, #e0e0e0);
  transition: all ease-in-out 0.4s;
  margin-left: ${(props) => (props.showsidebar === "true" ? "72px" : "0px")};
`;

const AppLayout = () => {
  const [width, setWidth] = useState("72px");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showSidebar, setShowSidebar] = useState<"true" | "false">("true");

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleRightClick = (e: Event) => {
      e.preventDefault();
    };

    document.body.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.body.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setShowSidebar("false");
      setWidth("0px");
    } else {
      setShowSidebar("true");
      setWidth("72px");
    }
  }, [windowWidth]);

  const location = useLocation();

  return (
    <div>
      {(showSidebar === "true" && (
        <SideBar setWidth={setWidth} width={width} />
      )) || <MobileSidebar setWidth={setWidth} width={width} />}

      <TopBar showSidebar={showSidebar} setWidth={setWidth} />
      <StyledMenu showsidebar={showSidebar}>
        <Outlet />
      </StyledMenu>
    </div>
  );
};

export default AppLayout;
